export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
export const UTM_SESSION_KEY = "initial_utm_params";

export const captureUtmParams = (): void => {
  const currentParams = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();

  UTM_KEYS.forEach((k) => {
    const val = currentParams.get(k);
    if (val) {
      utmParams.set(k, val);
    }
  });

  if (utmParams.toString()) {
    sessionStorage.setItem(UTM_SESSION_KEY, utmParams.toString());
  }
};
